import styled from '@emotion/styled';
import { ReactNode, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useUser from '../../authentication/context/useUser';
import { useProject } from '../../project/context/useProject';

import { useTranslation } from 'react-i18next';
import useProjects from '../../project/context/useProjects';
import ProjectActions from '../../project/ProjectActions';
import Button from '../../ui/Button';
import UserMenu from '../UserMenu';
import { ProjectBreadcrumb } from './ProjectBreadCrumb';
import InfoMenu from './InfoMenu';

export const HeaderContainer = styled.header`
  height: 64px;
  width: 100%;
  position: sticky;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px;
  top: 0;
  background-color: var(--PURPLE);
  z-index: 80;
`;

export const LogoWrapper = styled.img`
  max-width: 400px;
  max-height: 95%;
  cursor: pointer;
`;

export const HeaderProject = () => {
  const { projectId } = useParams();
  const { project } = useProject(projectId);
  const { user } = useUser();

  if (!project) return null;
  return (
    <HeaderContainer>
      <HeaderSection marginBetween="16px">
        {project && <ProjectBreadcrumb project={project!} />}
        <ProjectActions project={project} />
      </HeaderSection>
      <HeaderSection marginBetween="16px">
        <InfoMenu />
        <UserMenu />
      </HeaderSection>
    </HeaderContainer>
  );
};

export const AppActions = () => {
  const { projects } = useProjects();
  const shouldDisplayReports =
    projects?.find((p) => p.model.type === 'other_radio_services') !==
    undefined;
  return (
    <>
      {shouldDisplayReports && <ReportEdition />}
      <InfoMenu />
      <UserMenu />
    </>
  );
};

const ReportEdition = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const { t } = useTranslation(['annual-reports']);

  return (
    <>
      <Button
        color="secondary"
        aria-controls={open ? 'menu-button' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={() => navigate('/annual-reports')}
        variant="contained"
      >
        {t('annual-reports:header_button').toLocaleUpperCase()}
      </Button>
    </>
  );
};

export const HeaderProjects = () => {
  const navigate = useNavigate();
  return (
    <HeaderContainer>
      <HeaderSection marginBetween="16px">
        <LogoWrapper
          id="logoWrapper"
          src="/SONAR LOGO HORIZONTAL - Filaire blanc - 2025.png"
          alt="logo"
          onClick={() => navigate('/')}
        />
      </HeaderSection>
      <HeaderSection marginBetween="16px">
        <AppActions />
      </HeaderSection>
    </HeaderContainer>
  );
};

type HeaderSectionProps = {
  centered?: boolean;
  marginBetween?: string;
  children: ReactNode;
};

const HeaderSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  position: ${(props: HeaderSectionProps) =>
    props.centered ? 'absolute' : ''};
  left: ${(props: HeaderSectionProps) => (props.centered ? '50%' : '')};
  transform: ${(props: HeaderSectionProps) =>
    props.centered ? 'translate(-50%, 0)' : ''};
  > *:not(:last-child) {
    margin-right: ${(props: HeaderSectionProps) =>
      props.marginBetween ? props.marginBetween : ''};
  }
`;
export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const HeaderSection = ({
  marginBetween,
  centered,
  children,
}: HeaderSectionProps) => {
  return (
    <HeaderSectionWrapper marginBetween={marginBetween} centered={centered}>
      {children}
    </HeaderSectionWrapper>
  );
};

export const HeaderButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: white;
  p {
    font-family: 'Lexend Exa', sans-serif !important;
  }
`;
